import React from 'react';
import Helmet from 'react-helmet';

import AboutBlock from '../components/AboutBlock';

const About = () => (
    <div className="simple-col-wrapper index-1">
        <Helmet title="About" />
        <AboutBlock />
    </div>
);

export default About;



/** WEBPACK FOOTER **
 ** ./src/pages/About.js
 **/